import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Turns out I'll be writing a book",
  "description": "",
  "published": "2012-09-11T00:00:00.000Z",
  "redirect_from": ["/blog/turns-out-ill-be-writing-a-book/swizec/5248"],
  "categories": "Arts, Author, Book Writing, Landing page, Literature, Uncategorized, Writing",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Last week there was a lull in exams - that I now almost regret indulging - and as often happens ideas started flowing. Plenty of ideas for new products, `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/a-message-from-your-future-self/swizec/3377"
      }}>{`productifying old prototypes`}</a>{` and so on.`}</p>
    <p>{`An idea I'd had a few weeks ago came back to me, what if I was to write a book? It seems I can get a few people to read my blogposts, would they read a book?`}</p>
    <h2 {...{
      "id": "write-a-book"
    }}>{`Write a book?`}</h2>
    <p>{`On Thursday I set out to test the book idea. With more readers than all the other posts on this blog combined, `}<em parentName="p"><a parentName="em" {...{
          "href": "http://swizec.com/blog/why-programmers-work-at-night/swizec/3198",
          "title": "Why programmers work at night"
        }}>{`Why programmers work at night`}</a></em>{` was the perfect candidate for a topic.`}</p>
    <p>{`After re-reading that essay thing, I realized it's full of assumptions supported by anecdotal evidence from a group of one, arm-chair-science reasoning about causes and atrocious writing.`}</p>
    <p>{`I can totally do better!`}</p>
    <p>{`By evening the pitch was written, basic goals outlined and a landing page set up on leanpub. -> `}<a parentName="p" {...{
        "href": "https://leanpub.com/nightowls"
      }}>{`https://leanpub.com/nightowls`}</a></p>
    <p>{`Writing the book I want to talk to as many programmers of all types as possible, conduct short interviews with them to be featured in the book, conduct a survey or two and once and for all answer three important questions:`}</p>
    <ol>
      <li parentName="ol">{`_`}{`D_o programmers work at night?`}</li>
      <li parentName="ol">{`Does this happen more than in other creative disciplines?`}</li>
      <li parentName="ol">{`How the hell do you handle a night-time programmer in your life?`}</li>
    </ol>
    <p>{`The experiment was simple, if I can get 100 people to sign up by the end of September I was going to write the book.`}</p>
    <p>{`So far `}<strong parentName="p">{`238 `}</strong>{`have signed up. Most within the first 48 hours of the page being up. Hooray `}{`\\`}{`o/`}</p>
    <p>{`Right, now I have this book to write ... it's a bit scary, very exciting and I `}<em parentName="p">{`think`}</em>{` I can pull it off. But we won't know for certain until I do.`}</p>
    <p>{`Here's the plan:`}</p>
    <ol>
      <li parentName="ol">{`In October I start conducting interviews - send me an email at `}<a parentName="li" {...{
          "href": "mailto:swizec+nightowls@swizec.com"
        }}>{`swizec+nightowls@swizec.com`}</a>{` if you want to help`}</li>
      <li parentName="ol">{`By November I want to publish the first minimum viable book, a beta version if you will`}</li>
      <li parentName="ol">{`By December the book should be in a final state and publishable "for real"`}</li>
      <li parentName="ol">{`Continue updating the text as new ideas/info surfaces and publish an updated version every couple of months`}</li>
    </ol>
    <p>{`To make things more interesting, I'm writing the book out in the open on github -> `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/nightowls"
      }}>{`https://github.com/Swizec/nightowls`}</a>{`. There I will be accepting bug reports, anything you feel is wrong, just tell me.`}</p>
    <p>{`Oh and you get to see the content before it's published, but pdf's are nicer to read than markdown files ;)`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://indiewritingblog.com/2012/09/10/its-a-dirty-job-guest-post-by-kasia-james/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/111284908_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://indiewritingblog.com/2012/09/10/its-a-dirty-job-guest-post-by-kasia-james/"
        }}>{`It's a Dirty Job... (Guest Post by Kasia James)`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://onlinejournalismblog.com/2012/08/29/how-to-teach-a-journalist-programming/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/109257994_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://onlinejournalismblog.com/2012/08/29/how-to-teach-a-journalist-programming/"
        }}>{`How to teach a journalist programming`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://dlmilesbooks.wordpress.com/2012/09/10/use-simple-words/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/111208955_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://dlmilesbooks.wordpress.com/2012/09/10/use-simple-words/"
        }}>{`Use Simple Words`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://michaeljholley.com/2012/08/30/how-many-books-should-i-write-at-once/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/109484120_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://michaeljholley.com/2012/08/30/how-many-books-should-i-write-at-once/"
        }}>{`How Many Books Should I Write At Once?`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=fd8ae5c9-6ffe-41ce-b39d-94ea74960a6b",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      